import { render } from "./BtnGoBack.vue?vue&type=template&id=e7dca364&scoped=true"
const script = {}

import "@/css/components/btn-go-back.css?vue&type=style&index=0&id=e7dca364&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7dca364"]])

export default __exports__